<template>
  <div class="mail-sign-up">
    <form class="" action="index.html" method="post">
      <div class="form-group">
        <label for="email">{{ $t('auth.form.email') }}</label>
        <input class="form-control" type="text" id="email" v-model="email" required>
      </div>
      <div class="form-group">
        <label>{{ $t('auth.form.password') }}</label>
        <input class="form-control" type="password" v-model="password" autocomplete="on" required>
      </div>
      <button type="button" class="btn btn-info" @click="clicked">{{ $t('auth.button.signup') }}</button>
    </form>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'MailSignUp',
  props: {

  },
  data(){
    return{
      email: '',
      password: ''
    }
  },
  methods: {
    clicked(){
      this.createUser(this.email, this.password);
    },
    createUser(email, password){
      firebase.auth().createUserWithEmailAndPassword(email, password).then(()=>{
        this.$router.push('/');
      }).catch(function(error) {
        console.log(error.code);
        console.log(error.message);
      })
    }
  }
}
</script>
<style scoped>
</style>
